import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
import { useContext, useEffect, useState } from 'react';
import CustomFormLabel from '../../common/form-label/CustomFormLabel ';
import { iWebFormField } from '../schema';
import { FieldsContext } from '../WebFormWorkspace';

export const WebCheckBox = ({fieldConfig,value,editable,disabled=false,idNamespace}: {fieldConfig:iWebFormField,value?:any,editable?:boolean,disabled?:boolean,idNamespace?:string}) => {
    // const { fieldLabel = "",name="", placeholder = "Please Enter", isMandatory=false,fieldsOptions="Hi|Hello" } = props?.fieldConfig;
    const {fieldLabel,fieldOptions="",fieldDescription,isMandatory,id} = fieldConfig;
    const { errors } = useContext(FieldsContext);
    const errorMsg = errors?.[id];
    const [menuOptions,setOptions] = useState<string[]>([]);
    useEffect(()=>{
//         console.log('WebCheckBox_values',fieldConfig,fieldOptions)
        if(fieldOptions && fieldOptions !== ""){
            let vals = fieldOptions.split('|')
            setOptions(vals)
        }
    },[fieldOptions])
        return (
        <div>
            <CustomFormLabel
                labelName={fieldLabel}
                isMandotary={isMandatory}
            />
            {(fieldDescription && fieldDescription.trim() !== "") && <FormHelperText className="helper-text-webform">{fieldDescription}</FormHelperText>}
            <FormGroup className={`webForm-checkboxholder ${editable ? '' : 'readonly-checkbox'}`}>
                {menuOptions.length === 0 && 
                    <FormControlLabel 
                        name={`${id}`}
                        control={<Checkbox name=''  />} 
                        label={"Add Options..."} 
                        disabled
                    />
                }
                {menuOptions.map((i:any,index:number)=>{
                    const trimmedOption = i.trim(); 
                    const isChecked = value?.includes(trimmedOption)
                    return <FormControlLabel 
                        key={index} 
                        control={<Checkbox 
                                    value={trimmedOption} 
                                    name={`${idNamespace ? idNamespace + '_' : ''}checkBox_${id}_${trimmedOption}`} 
                                    size="small" defaultChecked={isChecked}
                                />} 
                         label={i} />
                })}
            </FormGroup>
            {errorMsg && ( <FormHelperText sx={{ color: "#ff0000 !important" }} error>{errorMsg}</FormHelperText>)}
        </div>
    )
}